var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2094_3975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.31094 12.9375L12.0187 9.22969L11.0672 8.27812L8.29453 11.0508L6.91641 9.67266L5.98125 10.6078L8.31094 12.9375ZM5.0625 15.5625C4.70156 15.5625 4.39258 15.434 4.13555 15.177C3.87852 14.9199 3.75 14.6109 3.75 14.25V3.75C3.75 3.38906 3.87852 3.08008 4.13555 2.82305C4.39258 2.56602 4.70156 2.4375 5.0625 2.4375H10.3125L14.25 6.375V14.25C14.25 14.6109 14.1215 14.9199 13.8645 15.177C13.6074 15.434 13.2984 15.5625 12.9375 15.5625H5.0625ZM9.65625 7.03125V3.75H5.0625V14.25H12.9375V7.03125H9.65625Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2094_3975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEt1);
export default __webpack_public_path__ + "static/media/ET1.a18a5f74f5094d838df1e338ca8ba490.svg";
export { ForwardRef as ReactComponent };